var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IxVectorLayer',{attrs:{"features":_vm.fieldFeatures,"layer-id":"fields","vector-style":_vm.styles.field,"cluster-style":_vm.styles.fieldCluster}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }